import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Button,
  Row,
  Col,
  Input,
  Switch,
  Avatar,
  Typography,
  Spin,
  Empty,
  InputNumber,
  Popover,
  List,
  Pagination,
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { SettingFilled, DeleteOutlined } from '@ant-design/icons';
import { useCreation } from '@umijs/hooks';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import unionBy from 'lodash/unionBy';
import map from 'lodash/map';
import filter from 'lodash/filter';
import get from 'lodash/get';
import each from 'lodash/each';
import moment from 'moment';
import useFetch from 'utils/fetch/useFetch';
import { BOX, USERS, MONITORING, BASE } from 'api';
import { fetchSuccess } from '../../../store/reducers/fetchSlice';
import { Scrollbars } from 'react-custom-scrollbars';
import Modal from '../../../components/Modal/index';
import DatePicker from '../../../components/DatePicker/index';
import { ReactComponent as NotAvalibleLock } from '../../../images/lock_gray_close.svg';
import { ReactComponent as Prefix } from '../../../images/3lines.svg';
import { ReactComponent as Arrow } from '../../../images/arrow-right.svg';
import { ReactComponent as CalendarIcon } from '../../../images/calendar.svg';
import { ReactComponent as Delete } from '../../../images/trash_gray.svg';
import { ReactComponent as NotAvalibleLockWhite } from '../../../images/lock_white_close.svg';
import { ReactComponent as DontatacchedIcon } from '../../../images/dontatacchedblue.svg';
import { ReactComponent as HistoryIcon } from '../../../images/book_history.svg';
import { ReactComponent as OpeRedLock } from '../../../images/open_lock_red.svg';
import { ReactComponent as OpeBlueLock } from '../../../images/close_lock_blue.svg';
import { ReactComponent as OpenGreenLock } from '../../../images/opengreenlock.svg';
import { ReactComponent as OpenLockBlue } from '../../../images/lock_blue_open.svg';
import { ReactComponent as Undef } from '../../../images/lock-undf-open.svg';
import { ReactComponent as AvalibleLock } from '../../../images/lock_green_close.svg';
import { ReactComponent as Bluekey } from '../../../images/blue_key.svg';
import { ReactComponent as Pen } from '../../../images/pen.svg';
import { ReactComponent as Changeuser } from '../../../images/change_user.svg';
import { ReactComponent as Seticon } from '../../../images/mec.svg';
import Logs from './Logs';

import { setStatusLock, stopRequest } from '../reducer/actions';

const Toggles = styled.div`
  &&& {
    width: 100%;
    padding: 20px 40px 0px 40px;
    .ant-switch {
      background-color: white;
      border: 1px solid #e2e3e3;
      margin-right: 10px;
      min-width: 39px !important;
      display: flex;
      height: 25px;
    }
    .ant-switch-handle {
      top: 1px;
      &:before {
        background-color: #e2e3e3;
        border: 1px solid #e2e3e3;
        box-shadow: none;
        border-radius: 100px;
        width: 21px;
        height: 21px;
      }
    }
    .ant-switch-checked {
      background-color: #e3f1ff;
      border: 1px solid #b3d5f9;
      .ant-switch-handle {
        &:before {
          background-color: #4b97e9;
          margin-left: -3px;
        }
      }
    }
    .item {
      display: flex;
      width: 100%;
      align-items: center;
      input {
        box-sizing: border-box;
        border-radius: 6px;
        margin-left: -5px;
        margin-right: 6px;
        border-color: #e2e3e3;
        border-radius: 6px;
        color: #9f9f9f;
        padding: 9px;
        padding-right: 0;
      }
      .ant-input-number {
        border-radius: 6px;
        margin-right: 5px;
      }
    }
    .ant-input-number-handler-wrap {
      display: none;
    }
  }
`;

const WrapperBody = styled.div`
  &&& {
    .ant-input-affix-wrapper-disabled {
      background: white;
    }
    .ant-picker.ant-picker-disabled {
      background: white;
    }
  }
`;

const BoxLogs = styled.div`
  &&& {
    li.ant-list-item.ant-list-item-no-flex {
      padding: 0;
      border: none !important;
    }
    .ant-list-pagination {
      text-align: center;
    }
    svg {
      margin-top: -6px;
    }
  }
`;

const { Paragraph } = Typography;

function BoxSetting({
  visible,
  setVisible,
  data,
  visibleAdd,
  setVisibleAdd,
  setBox,
  updateDevice,
  getBoxes,
  storageId,
  updateBox,
  allUsers,
  getAllUsers,
  source,
  setUser,
  cliendId,
  boxes,
  transaction,
  getTransactions,
  limit,
  getDevices,
  userVisible,
  setUserVisible,
}) {
  const [tab, setTab] = useState('history');
  const [editView, setEditView] = useState(false);
  const [name, setName] = useState(null);
  const [value, setValue] = useState(60);
  const [id, setId] = useState(null);
  const [infoLogs, setInfoLogs] = useState([]);
  const [beep, setBeep] = useState(false);
  const [reqLoad, setReqLoad] = useState(false);
  const totalLogs = useSelector((state) =>
    get(state, `fetch.box_logs.total`, null),
  );
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const scrollEl = useRef(null);
  const { data: logs, deleteData, getData, loading } = useFetch(
    `${BOX}/${data.id}/logs`,
    {
      uniqId: 'box_logs',
      autoFetch: false,
    },
  );

  const {
    data: settings,
    getData: getSettings,
    updateData: updateSettings,
    loading: loadingSettings,
  } = useFetch(`${BOX}/${data.id}/settings`, {
    uniqId: 'settings',
    autoFetch: false,
  });

  const { data: users, getData: getUsers } = useFetch(USERS, {
    uniqId: 'user',
    autoFetch: false,
    entityId: id,
  });

  const handleSetName = (e, id) => {
    setEditView(false);
    e.target
      .closest('.editWrapper')
      .querySelector('.ant-input')
      .classList.add('hidden');
    updateBox(
      {
        name: e.target.value,
        id,
      },
      {
        sync: false,
        getSyncData: {
          fetchFunc: source === 'transaction' ? getTransactions : getBoxes,
          params: {
            limit: source === 'transaction' ? limit : null,
            warehouse_id: source === 'transaction' ? null : storageId,
            transaction__client_id:
              source === 'transaction' ? null : source ? cliendId : null,
          },
        },
      },
    );
    setName(e.target.value);
  };

  const editVisible = (e) => {
    setEditView(!editView);
    e.target
      .closest('.editWrapper')
      .querySelector('.ant-input')
      .classList.remove('hidden');
    e.target.closest('.editWrapper').querySelector('.ant-input').focus();
  };

  const handleBeep = (e) => {
    updateSettings({
      door_beep: Number(e.target.value),
      door_beep_enabled: true,
    });
  };

  const handleBeepCheck = (value) => {
    if (!value) {
      setBeep(true);
      setValue(60);
      updateSettings({
        door_beep: 60,
        door_beep_enabled: false,
      });
    } else {
      setBeep(false);
      updateSettings({
        door_beep_enabled: true,
      });
    }
  };

  const handleDoorType = (setting) => {
    updateSettings({
      door_beep: value,
      door_beep_enabled: beep,
      door_type: setting ?  "GARAGE_DOOR" : "LOCK"
    });
  };

  const onChange = (value) => {
    setValue(value);
  };

  const handleOffLock = (id) => {
    updateDevice(
      {
        box_id: null,
        id,
      },
      {
        sync: false,
        getSyncData: {
          fetchFunc:
            source === 'transaction'
              ? getTransactions
              : source === 'devices'
              ? getDevices
              : getBoxes,
          params: {
            limit:
              source === 'transaction' || source === 'devices' ? limit : null,
            warehouse_id:
              source === 'transaction' || source === 'devices'
                ? null
                : storageId,
            transaction__client_id:
              source === 'transaction' || source === 'devices'
                ? null
                : source
                ? cliendId
                : null,
          },
        },
      },
    );
    setVisible(!visible);
    if (setVisibleAdd) {
      setVisibleAdd(!visibleAdd);
    }
  };

  const openBox = (id) => {
    if (!reqLoad) {
      dispatch(
        setStatusLock(id, storageId, 'open', {
          getBoxes,
          query: { warehouse_id: storageId },
        }),
      );
    }
    setReqLoad(true);
  };

  const closeBox = (id, currentStatus) => {
    dispatch(
      setStatusLock(id, storageId, 'close', {
        getBoxes,
        query: { warehouse_id: storageId },
      }),
    );
  };

  // const afterClose = () => {
  //   setBox(null);
  //   dispatch(stopRequest());
  //   if (setUser) {
  //     setUser(null);
  //   }
  // };

  const deleteBox = () => {
    deleteData({
      id: data.id,
    });
  };

  useEffect(() => {
    if (visible) {
      getData({
        limit: 50,
      });
      getSettings();
      if (!source) {
        getAllUsers();
      }
    } else {
      setInfoLogs([]);
    }
  }, [visible]);

  useEffect(() => {
    if (data.transaction) {
      setId(data.transaction.client_id);
    }
  }, [data]);

  //получаем инфу по юзеру
  useEffect(() => {
    if (id) {
      getUsers();
    }
  }, [id]);

  useMemo(() => {
    if (allUsers && logs) {
      const group = [];
      each(logs, (item) => {
        if (item.user) {
          group.push({ info: item, user: item.user });
        } else {
          group.push({ info: item });
        }
      });
      setInfoLogs(group);
    }
  }, [allUsers, logs]);

  const webSocket = useCreation(() => {
    const token = localStorage.getItem('access_token');
    return new WebSocket(`${MONITORING}?authorization=OAuth%20${token}`);
  });

  useEffect(() => {
    webSocket.onopen = () => {
      console.log('open');
    };
    webSocket.onclose = () => console.log('ws closed');
    return () => {
      webSocket.close();
    };
  }, []);

  useEffect(() => {
    if (source !== 'transaction') {
      if (source && data.device && boxes && logs) {
        webSocket.onmessage = function (event) {
          const response = JSON.parse(event.data);
          if (response.type === 'box') {
            dispatch(
              fetchSuccess({
                uniqId: 'boxes',
                response: { data: unionBy([response.data], boxes, 'id') },
              }),
            );
          } else if (
            logs &&
            (response.type === 'box_log_insert' ||
              response.type === 'box_log_update')
          ) {
            let copy = logs.slice(0);
            copy.unshift(response.data);
            dispatch(
              fetchSuccess({
                uniqId: 'box_logs',
                response: { data: copy },
              }),
            );
          }
        };
      }
    } else {
      if (source && data.device && transaction && logs) {
        webSocket.onmessage = function (event) {
          const response = JSON.parse(event.data);
          if (response.data.transaction && response.type === 'box') {
            const item = {
              ...response.data.transaction,
              box: response.data,
            };
            dispatch(
              fetchSuccess({
                uniqId: 'transactions',
                response: { data: unionBy([item], transaction, 'id') },
              }),
            );
          } else if (
            logs &&
            (response.type === 'box_log_insert' ||
              response.type === 'box_log_update')
          ) {
            let copy = logs.slice(0);
            copy.unshift(response.data);
            dispatch(
              fetchSuccess({
                uniqId: 'box_logs',
                response: { data: copy },
              }),
            );
          }
        };
      }
    }
  }, [boxes, source, logs, data, transaction]);

  const openUserModal = (user) => {
    setVisible(!visible);
    setUser(user);
    setUserVisible(!userVisible);
  };

  useEffect(() => {
    if (data.device && data.device.telemetry.open && reqLoad) {
      setReqLoad(false);
    }
  }, [data.device]);

  const afterClose = () => {
    setBox(null);
  };

  return (
    <>
      <Modal
        afterClose={() => {
          afterClose();
        }}
        visible={visible}
        width={727}
        setVisible={setVisible}
      >
        <div className="mt-10">
          <div className="relative h-70 pl-40">
            <Row className="h-full" align="middle" type="flex">
              <Col span={11}>
                <div className="editWrapper flex items-center">
                  {!editView && (
                    <div className="text-20 font-bold text-black">
                      {data.name}
                    </div>
                  )}
                  <Pen
                    onClick={(e) => {
                      editVisible(e);
                    }}
                    className={`${
                      editView ? 'hidden' : 'block'
                    } cursor-pointer ml-10`}
                  />

                  <Input
                    className="hidden text-20 font-bold text-black pl-0 mb-0 pb-0 mt-0 pt-0 border-0 focus:border-0 focus:shadow-none"
                    onBlur={(e) => {
                      handleSetName(e, data.id);
                    }}
                    defaultValue={data.name}
                  />
                </div>

                <div>{data.section.warehouse.address}</div>
              </Col>
              {tab === 'history' ? (
                <Col className="flex items-center" span={12}>
                  {' '}
                  <SettingFilled
                    style={{ color: '#4b97e9', marginRight: '5px' }}
                  />
                  <Button
                    onClick={() => {
                      setTab('setting');
                    }}
                    loading={loadingSettings}
                    type="link"
                    className="pl-0"
                  >
                    <span className="text-primary border-b border-dotted border-linkLine">
                      {t('settings')}
                    </span>
                  </Button>
                </Col>
              ) : (
                <Col className="flex items-center" span={12}>
                  {' '}
                  <HistoryIcon className="mr-1 mt-1" />
                  <Button
                    type="link"
                    onClick={() => {
                      setTab('history');
                    }}
                    className="pl-0"
                  >
                    {t('historyOperation')}
                    {/* adfafsadfsalkdjf */}
                  </Button>
                </Col>
              )}
            </Row>
            <div className="absolute top-0 right-0 rounded-bl-lg flex bg-gray h-full rounded-tr-md w-220 items-center justify-center">
              {data.available ? (
                //открыт арендатором
                data.device.telemetry.open &&
                (data.device.open_close_type === 'button' ||
                  (data.device.open_close_type === 'backend' &&
                    data.device.open_close_user.role === 'client') ||
                  (data.device.open_close_type === 'bluetooth' &&
                    data.device.open_close_user.role === 'client')) ? (
                  <>
                    <span
                      className={
                        data.expired
                          ? 'rounded-full border-red border-2 h-35 w-35 pl-8 pt-6 mr-10'
                          : null
                      }
                    >
                      <OpenLockBlue className={data.expired ? null : 'mr-10'} />
                    </span>
                    <span>{t('openUser')}</span>
                  </>
                ) : //открыт админом
                data.device.telemetry.open &&
                  data.device.open_close_type === 'backend' &&
                  data.device.open_close_user.role === 'admin' ? (
                  <>
                    <span
                      className={
                        data.expired
                          ? 'rounded-full border-red border-2 h-35 w-35 pl-8 pt-6 mr-10'
                          : null
                      }
                    >
                      <OpenGreenLock
                        className={data.expired ? null : 'mr-10'}
                      />{' '}
                    </span>
                    <span>{t('openAdmin')}</span>
                  </>
                ) : data.device.telemetry.open &&
                  !data.device.open_close_type ? (
                  <>
                    {' '}
                    <Undef className="mr-5 ml-10" />{' '}
                    <span className="text-center">{t('undefOpen')}</span>
                  </>
                ) : (
                  <>
                    <span
                      className={
                        data.expired
                          ? 'rounded-full border-red border-2 h-35 w-35 pl-8 pt-6 mr-10'
                          : null
                      }
                    >
                      {' '}
                      <AvalibleLock className="mr-10 ml-5" />{' '}
                    </span>
                    <span className="text-center">{t('boxAvailable')}</span>
                  </>
                )
              ) : (
                <>
                  <span
                    className={
                      data.expired
                        ? 'rounded-full border-red border-2 h-35 w-35 pl-8 pt-6 mr-10'
                        : 'flex'
                    }
                  >
                    <NotAvalibleLock className="mr-10" />
                  </span>
                  <span>{t('boxNotAvailabel')}</span>
                </>
              )}
            </div>
          </div>
          <WrapperBody>
            <div className="pl-40 mt-20 mb-20">
              <Row className="h-full" align="middle" type="flex">
                <Col span={10}>
                  <Input
                    disabled={true}
                    value={
                      users ? `${users.first_name} ${users.last_name}` : null
                    }
                    className="rounded-xs h-50"
                    prefix={<Prefix className="mr-10" />}
                  />
                </Col>
                <Col span={1}>
                  <Arrow className="ml-4 mr-4" />
                </Col>
                <Col span={7}>
                  <DatePicker
                    disabled={true}
                    value={data.transaction ? data.transaction.paid_till : null}
                    className="rounded-xs h-50 w-full ml-4"
                    suffixIcon={<CalendarIcon />}
                  />
                </Col>
              </Row>
              {/* <Message className="relative flex items-center mt-15 mb-15 justify-center w-10/12 bg-gray p-10 rounded-xs">
              {t('changecellOwner')} Александр Иванченко?
              <div className="ml-80">
                <Button className="rounded-xs" type="primary">
                  {t('yes')}
                </Button>
                <Button className="rounded-xs ml-10"> {t('no')}</Button>
              </div>
            </Message> */}
            </div>
          </WrapperBody>
          {tab === 'history' ? (
            <>
              <div className="mb-5 flex items-center justify-between">
                <div className="h-px bg-gray w-2/5"></div>
                <div className="text-md text-black font-semibold">
                  {t('historyOperation')}
                </div>
                <div className="h-px bg-gray w-2/5"></div>
              </div>
              <Spin spinning={loading}>
                <Scrollbars
                  ref={scrollEl}
                  renderTrackHorizontal={(props) => (
                    <div
                      {...props}
                      className="track-horizontal"
                      style={{ display: 'none' }}
                    />
                  )}
                  renderThumbHorizontal={(props) => (
                    <div
                      {...props}
                      className="thumb-horizontal"
                      style={{ display: 'none' }}
                    />
                  )}
                  style={{ height: 200 }}
                >
                  {' '}
                  {console.log((totalLogs / 50) * 10, 'infoLogs')}
                  {infoLogs.length !== 0 ? (
                    <BoxLogs>
                      <List
                        itemLayout="vertical"
                        size="large"
                        dataSource={infoLogs}
                        renderItem={(item, index) => (
                          <List.Item key={index}>
                            <Logs openUserModal={openUserModal} data={item} />
                          </List.Item>
                        )}
                      />
                      {totalLogs > 50 ? (
                        <div className="pt-20 mb-10 flex justify-center">
                          <Pagination
                            showSizeChanger={false}
                            onChange={(page) => {
                              scrollEl.current.scrollTop(0);
                              if (page !== 1) {
                                getData({
                                  offset: page * 10,
                                  limit: 50,
                                });
                              } else {
                                getData({
                                  limit: 50,
                                });
                              }
                            }}
                            defaultCurrent={1}
                            total={totalLogs - 10}
                          />
                        </div>
                      ) : null}
                    </BoxLogs>
                  ) : (
                    <Empty />
                  )}
                  {/* {infoLogs.length !== 0 ? (
                    map(infoLogs, (item) => {
                      return (
                        <Logs
                          openUserModal={openUserModal}
                          data={item}
                          user={item.user}
                          open_close_type={item.info.open_close_type}
                          type={item.info.type}
                          date={moment(item.info.datetime)
                            .subtract(
                              new Date(item.info.datetime).getTimezoneOffset(),
                              'minutes',
                            )
                            .format('DD MMMM HH:mm')}
                        />
                      );
                    })
                  ) : (
                    <Empty />
                  )} */}
                </Scrollbars>
              </Spin>
            </>
          ) : (
            <>
              <div className="flex items-center justify-between">
                <div className="h-px bg-gray w-2/5"></div>
                <div className="text-md text-black font-semibold">
                  {t('settings')}
                </div>
                <div className="h-px bg-gray w-2/5"></div>
              </div>
              {data.device ? (
                <div className="pt-20 pr-40 pb-20 pl-60 ">
                  <Row justify="space-between" align="middle" type="flex">
                    <Col span={4}>
                      <div
                        className={`${
                          !data.device.online ? 'bg-red' : 'bg-online'
                        } w-8 h-8 rounded-full absolute top-18 status -left-17`}
                      ></div>
                      <div className="text-graytext text-12 mb-4">ID:</div>
                      <div className="font-medium text-black">
                        {data.device.id}
                      </div>
                    </Col>
                    <Col span={6}>
                      <div className="text-graytext text-12 mb-4">
                        {t('macAdress')}:
                      </div>
                      <div className="font-medium text-black">
                        <Paragraph
                          className="font-medium text-black"
                          style={{ marginBottom: 0 }}
                          ellipsis
                        >
                          {data.device.serial}
                        </Paragraph>
                      </div>
                    </Col>
                    <Col span={4}>
                      <div className="text-graytext text-12 mb-4">
                        {t('firmware')}:
                      </div>
                      <div className="font-medium text-black">
                        {data.device.telemetry.version}
                      </div>
                    </Col>
                    <Col span={5}>
                      <Button
                        onClick={() => {
                          handleOffLock(data.device.id);
                        }}
                        className="bg-btn-small h-29 pr-10 pl-10 hover:bg-btn-small rounded-xs border-0 flex items-center text-primary"
                      >
                        <DontatacchedIcon
                          style={{ width: '30px' }}
                          className="mr-8"
                        />
                        {t('disable')}
                      </Button>
                    </Col>
                  </Row>
                </div>
              ) : null}
              {data.device ? (
                <Toggles>
                  <Row align="middle" type="flex">
                    <Col span={6}>
                      <div className="item">
                        <Switch />
                        {t('lightsignal')}
                      </div>
                    </Col>
                    <Col span={6}>
                      <div className="item">
                        <Switch />
                        {t('soundsignal')}
                      </div>
                    </Col>
                    <Col span={7}>
                      <div className="item">
                        <Switch
                          onChange={handleBeepCheck}
                          defaultChecked={settings.door_beep ? true : false}
                        />
                        {t('alarmAfter')}
                      </div>
                    </Col>
                    <Col span={3}>
                      <div className="item">
                        <InputNumber
                          disabled={beep ? true : false}
                          onBlur={handleBeep}
                          defaultValue={settings.door_beep}
                          value={
                            settings.door_beep ? settings.door_beep : value
                          }
                          onChange={onChange}
                        />
                        {t('minutes')}
                      </div>
                    </Col>
                  </Row>
                  <Row align="middle" type="flex">
                  <Col span={12} type="flex" style={{display: 'flex', alignItems: 'center'}}>
                      <span>Lock </span>
                      <div className="item"  style={{ width: 'auto', padding: '0 10px' }}>
                        <Switch
                          // checked={settings.door_type === "GARAGE_DOOR"}
                          onChange={handleDoorType}
                          defaultChecked={settings.door_type === "GARAGE_DOOR"}
                         
                        />
                        {/* {t('doorType')} */}
                      </div>
                      <span>Garage door </span>
                        {/* <span>{settings.door_type}</span> */}
                    </Col>
                  </Row>
                </Toggles>
              ) : null}
              {data.device ? (
                <div className="pt-30 pr-40 pb-20 pl-40">
                  <Row gutter={[30, 8]} align="middle" type="flex">
                    <Col span={8}>
                      <Button
                        onClick={() => {
                          openBox(data.id, data.device.telemetry.open);
                        }}
                        loading={reqLoad}
                        disabled={!data.device.telemetry.open ? false : true}
                        size="large"
                        className="w-full pl-23 flex items-center"
                        type="primary"
                      >
                        <div className="flex items-center justify-between w-full">
                          <NotAvalibleLockWhite
                            style={{ width: '16px', height: '21px' }}
                            className="mr-8"
                          />{' '}
                          <div className="w-full">{t('open')}</div>
                        </div>
                      </Button>
                    </Col>
                    {/* <Col span={8}>
                      <Button
                        size="large"
                        // disabled={data.device.telemetry.open ? false : true}
                        onClick={() => {
                          closeBox(data.id, data.device.telemetry.open);
                        }}
                        className="w-full pl-23 flex items-center"
                        type="danger"
                      >
                        <div className="flex items-center justify-between w-110">
                          <NotAvalibleLockWhite
                            style={{ width: '16px', height: '21px' }}
                            className="mr-8"
                          />
                          {t('block')}
                        </div>
                      </Button>
                    </Col> */}
                    <Col span={8}>
                      <Button
                        onClick={() => {
                          deleteBox();
                        }}
                        size="large"
                        className="w-full border-0 flex items-center justify-center"
                        type="ghost"
                      >
                        <Delete className="mr-8" /> {t('deleteBox')}
                      </Button>
                    </Col>
                  </Row>
                </div>
              ) : null}
            </>
          )}
        </div>
      </Modal>
    </>
  );
}

BoxSetting.propTypes = {};

export default BoxSetting;
